import { Header, HeaderActionBack, HeaderActionCustomerService } from "@/components/Header";
import { Layout } from "@/components/Layout";
import { useLogic } from "./useLogic";
import { DynamicForm } from "../trade/components/DynamicForm";
import { dictMap, formItems } from "./data";
// import { Description } from "./Description";
import styles from './index.module.scss';
import { useMemo } from "react";
import { Button } from "antd-mobile";
import { CryptoTradingProvider } from "@/stores/cryptoTradingContext";
import { Description } from "./Description";
export const Wrapper = () => {
  const logic = useLogic();
  const formFooter = useMemo(() => {
    return <div className={styles.footer}>
      <Button className={"common-submit-button"} onClick={() => {
        logic.onSubmit();
      }}>
        {logic.isTrading ? '查看订单' : '确定转入'}
      </Button>
    </div>;
  }, [logic.isTrading, logic.onSubmit]);
  const paymentType = useMemo(() => {
    return logic.data.paymentType ? logic.data.paymentType[0] : '';
  }, [logic.data.paymentType]);
  return <Layout scrollable backgroundImage={false} header={<Header title="商家余额充值" leftActions={<HeaderActionBack />} rightActions={<HeaderActionCustomerService />} />} data-sentry-element="Layout" data-sentry-component="Wrapper" data-sentry-source-file="index.tsx">
      <div className={styles.main}>
        <div className={styles.qrCode}>
          {logic.isTrading && logic.cryptoAccountInfo.address ? <img className="QRcode" alt="qr code" /> : null}
        </div>
        {paymentType ? <div className={styles.tip}>
          <div className={styles.paymentType}>此地址只可接受 {paymentType}</div>
        </div> : null}
        <div className={styles.form}>
          <DynamicForm disabled={logic.isTrading} data={logic.data} dictMap={dictMap} items={formItems} onRef={logic.onFormRef} onValuesChange={logic.onValuesChange} data-sentry-element="DynamicForm" data-sentry-source-file="index.tsx" />
        </div>
        <Description data-sentry-element="Description" data-sentry-source-file="index.tsx" />
      </div>
      
      {/* <Description /> */}
      {formFooter}
    </Layout>;
};
export const PageTransInBalanceFromBlockchain = () => {
  return <CryptoTradingProvider data-sentry-element="CryptoTradingProvider" data-sentry-component="PageTransInBalanceFromBlockchain" data-sentry-source-file="index.tsx">
    <Wrapper data-sentry-element="Wrapper" data-sentry-source-file="index.tsx" />
  </CryptoTradingProvider>;
};